import { createElementIdSlice } from '../utils/action/createElementSlice';
export const CheckboxListState = createElementIdSlice({
    elementName: 'checkbox-list',
    initialState: {},
    reducers: {},
});
